import { useReducer } from 'react';
import { toggleItemInArray } from '@utils/common';

/**
 * manages state related to filters.
 *
 * NB: applying filters should be done using the `applyFilters()` utility.
 */
function useFilters() {
  return useReducer(filtersReducer, initialState);
}
const initialState = {
  selectedCourseCounts: [],
  selectedGrades: []
};
function filtersReducer(state, action) {
  switch (action.type) {
    case "grade":
      return {
        ...state,
        selectedGrades: toggleItemInArray(state.selectedGrades, action.payload)
      };
    case "course-count":
      return {
        ...state,
        selectedCourseCounts: toggleItemInArray(state.selectedCourseCounts, action.payload, {
          findIndex: (arr, item) => arr.findIndex(it => it.from === item.from && it.to === item.to)
        })
      };
    case "reset":
      return initialState;
  }
}

export { useFilters };
//# sourceMappingURL=hook.filters.js.map
